import { Col, Row } from 'react-bootstrap';
import CampaignList from 'pages/hvamanagement/CampaignStartStopList';

const CampaignRecordingExplorer = () => {
  return (
    <>
      <Row className="gy-3 mb-6 justify-content-between">
        <Col>
          <h2 className="mb-2 text-body-emphasis">
            Start calling on your campaigns
          </h2>
          <h5 className="text-body-tertiary fw-semibold">
            Check actual campaign workload and start calling
          </h5>
        </Col>
      </Row>
      <Row className="gy-3 mt-3 justify-content-between">
        <CampaignList />
      </Row>
    </>
  );
};

export default CampaignRecordingExplorer;
